import React, { useState, createContext, useContext } from 'react'
const LayoutContext = createContext()

export default LayoutContext
